import React from 'react';
import { AquaristTemplate } from 'templates';
import { AquaristHeroSection } from 'organisms';

const AquaristPage: React.FC = () => {
  return (
    <AquaristTemplate>
      <AquaristHeroSection />
    </AquaristTemplate>
  );
};

export default AquaristPage;
